import React from 'react';
import StyledButton from './button.styled';
var Button = function Button(_ref) {
    var width = _ref.width, label = _ref.label, onClick = _ref.onClick, _ref$height = _ref.height, height = _ref$height === void 0 ? 3 : _ref$height, isDisabled = _ref.isDisabled, className = _ref.className;
    return /*#__PURE__*/ React.createElement(StyledButton, {
        width: width,
        height: height,
        onClick: onClick,
        isDisabled: isDisabled || false,
        className: className || ''
    }, label);
};
export default Button;
